module.exports = __webpack_public_path__ + "img/banco_popular.c7362228.png";